const typesForSelect = {
    typesForSelectLoadSuccess: (state, payload) => {
        state.typesForSelect = payload;
        state.isLoadedTypesForSelect = true;
    },
    typesForSelectLoadFailure: (state, payload) => {
        state.typesForSelectLoadFailure = payload;
    },
};

const limitsTemplates = {
    limitsTemplatesLoaded: (state, payload) => {
        state.limitsTemplates = payload;
        state.limitsTemplatesIsLoaded = true;
    },
};

const sidebetNames = {
    sidebetNamesLoaded: (state, payload) => {
        state.sidebetNames = payload;
        state.sidebetNamesIsLoaded = true;
    },
};

const operatorsForSelect = {
    operatorsForSelectLoadSuccess: (state, payload) => {
        state.operatorsForSelect = payload;
        state.isLoadedOperatorsForSelect = true;
    },
    operatorsForSelectLoadFailure: (state, payload) => {
        state.operatorsForSelectLoadFailure = payload;
    },
};

const currenciesForSelect = {
    currenciesForSelectLoadSuccess: (state, payload) => {
        state.currenciesForSelect = payload;
        state.isLoadedCurrenciesForSelect = true;
    },
    currenciesForSelectLoadFailure: (state, payload) => {
        state.currenciesForSelectLoadFailure = payload;
    },
};

const defaultSettings = {
    defaultSettingsLoadSuccess: (state, {gameType, settings}) => {
        state.defaultSettings[gameType] = settings;
        state.isLoadedDefaultSettings[gameType] = true;
    },
    defaultSettingsLoadFailure: (state, {gameType, error}) => {
        state.defaultSettingsLoadFailure[gameType] = error;
    },
};

const copyFilter = {
    loadCopyFilter: (state, {currencies, tables}) => {
        state.copyFilterCurrencies = currencies;
        state.copyFilterTables = tables;
    },
    loadCopyFilterFailure: (state, err) => {
        state.copyFilterFailure = err;
    }
}

export default {
    ...typesForSelect,
    ...operatorsForSelect,
    ...currenciesForSelect,
    ...defaultSettings,
    ...copyFilter,
    ...limitsTemplates,
    ...sidebetNames
}
